export const ACCOUNT_NAV = [
  { to: "/account", label: "Overview" },
  { to: "/account/profile", label: "Profile & security" },
  { to: "/account/billing", label: "Subscription & billing" },
  { to: "/account/usage", label: "Usage & benefits" },
  { to: "/account/preferences", label: "Preferences" },
  { to: "/account/privacy", label: "Privacy & support" },
];

export const ACCOUNT_KNOWN_SUBPATHS = new Set([
  "",
  "profile",
  "billing",
  "usage",
  "preferences",
  "privacy",
  "deletion-status",
]);
